import { render, staticRenderFns } from "./ModalTransLogs.vue?vue&type=template&id=7faefb94"
import script from "./ModalTransLogs.vue?vue&type=script&lang=js"
export * from "./ModalTransLogs.vue?vue&type=script&lang=js"
import style0 from "./ModalTransLogs.vue?vue&type=style&index=0&id=7faefb94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports